<div class="ht-menu-wrapper">
    <div class="ht-menu-area">
        <button class="ht-menu-toggle" (click)="closeMobileMenu()"><i class="bi bi-x-lg"></i></button>
        <div class="mobile-logo">
            <a routerLink="/">
                <img src="../../../assets/img/05_1.jpeg" alt="Header-logo">
            </a>
        </div>
        <div class="mobile-menu-wrapper d-lg-none d-inline-block">
            <div class="mobile-menu">
                <ul class="menu-list">
                    <!-- Login button at the top -->
                    <li>
                        <a *ngIf="!baseService.IsUserLoggedIn" routerLink="/login" (click)="closeMobileMenu()">Login</a>
                        <a *ngIf="baseService.IsUserLoggedIn" (click)="logout(); closeMobileMenu()">Logout</a>
                    </li>
                    <li>
                        <a routerLink="/about" (click)="closeMobileMenu()">About Us</a>
                    </li>
                    <li>
                        <a routerLink="/services" (click)="closeMobileMenu()">Services</a>
                    </li>
                    <li>
                        <a routerLink="/services-details" (click)="closeMobileMenu()">How It Works</a>
                    </li>
                    <li>
                        <a routerLink="/contact" (click)="closeMobileMenu()">Contact</a>
                    </li>
                </ul>
            </div>
        </div>
        <!-- <div class="offset-widget mb-40">
            <div class="info-widget">
                <h4 class="offset-title mb-20">About Us</h4>
                <p class="mb-30">
                    But I must explain to you how all this mistaken idea of denouncing pleasure and
                    praising pain was born and will give you a complete account of the system and
                    expound the actual teachings of the great explore
                </p>
            </div>
        </div> -->
        <!-- <div class="offset-widget mb-30 pr-10">
            <div class="info-widget info-widget2">
                <h4 class="offset-title mb-20">Contact Info</h4>
                <p>
                    <i class="fal fa-address-book"></i>
                    23/A, Miranda City Likaoli Prikano, Dope
                </p>
                <p>
                    <i class="fal fa-phone"></i>
                    +0989 7876 9865 9
                </p>
                <p>
                    <i class="fal fa-envelope-open"></i>
                    info&#64;example.com
                </p>
            </div>
        </div> -->
        <!-- Mobile Cart Section -->
        <!-- <div class="mobile-cart-auth mb-30">
            <div class="d-flex align-items-center justify-content-between mb-20">
                <div class="cart-menu" *ngIf="baseService.IsUserLoggedIn">
                    <a class="shopping-cart" (click)="goDashboard()">
                        <i class="bi bi-bag"></i>
                        <span class="ms-2">Dashboard</span>
                    </a>
                </div>
            </div>
        </div> -->

    </div>
</div>